// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomCell_wrapper__1F2aA","highlighted":"CustomCell_highlighted__2Ckc5"};